/**
 * Shared assessment configuration
 * Used by both NutritionLanding and ExerciseLanding
 */

// Color per suggestion level (index 0 = lowest score range, index 4 = highest)
export const LEVEL_COLORS = [
  '#EE1811', // ปรับปรุง
  '#FFA84E', // ควรปรับปรุง
  '#FFC92B', // ปานกลาง
  '#8BC34A', // ค่อนข้างดี
  '#72CC50', // สมดุล
];

// Status labels matching each level
export const LEVEL_LABELS = [
  'ปรับปรุง',
  'ควรปรับปรุง',
  'ปานกลาง',
  'ค่อนข้างดี',
  'สมดุล',
];
